module.exports = "/assets/300f3ba2de3b77dc92d59017fc23a0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/RO.png
// module id = 2915
// module chunks = 0